import { Modal, Tag, Typography } from "antd";
import { baseUrl } from "../../../services/api";
import {
  FaBook,
  FaEye,
  FaLinkedin,
  FaLocationDot,
  FaTwitter,
  FaUser,
  FaYoutube,
} from "react-icons/fa6";
import { MdEmail } from "react-icons/md";
import {
  FaCalendarAlt,
  FaClock,
  FaFileAlt,
  FaGraduationCap,
  FaInstagramSquare,
  FaPhoneAlt,
} from "react-icons/fa";
import { IoBookSharp, IoDocuments } from "react-icons/io5";
import { PiChalkboardTeacherFill } from "react-icons/pi";
import "./style.module.css";
import { useEffect, useState } from "react";
import {
  Tabs,
  TabsList,
  TabsTrigger,
  TabsContent,
} from "../../../components/custom-tabs";
import { FiMapPin } from "react-icons/fi";
import styles from "./style.module.css";
import { Card, CardContent, CardHeader, CardTitle } from "./components/card";
import { Badge } from "./components/badge";
import defaultCover from "../../../assets/images/cover-4.webp";
import { GoDotFill } from "react-icons/go";
import { formatInternationalPhoneNumber } from "../../../helper";

const TeacherProfilePreviewV2 = ({ teacherData, online }) => {
  const [activeTab, setActiveTab] = useState("overview");
  const [screenSize, setScreenSize] = useState("large");
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [selectedVideoUrl, setSelectedVideoUrl] = useState("");

  useEffect(() => {
    const updateScreenSize = () => {
      const width = window.innerWidth;
      if (width <= 768) {
        setScreenSize("small");
      } else if (width <= 1024) {
        setScreenSize("medium");
      } else {
        setScreenSize("large");
      }
    };

    updateScreenSize();
    window.addEventListener("resize", updateScreenSize);

    return () => {
      window.removeEventListener("resize", updateScreenSize);
    };
  }, []);

  const tabsData = [
    { value: "overview", label: "Overview", icon: FaEye },
    { value: "subjects", label: "Subjects", icon: FaBook },
    { value: "schedule", label: "Schedule", icon: FaCalendarAlt },
    { value: "documents", label: "Media", icon: FaFileAlt },
  ];

  // Transform media data to documents format
  const documents =
    teacherData?.media?.map((doc) => ({
      url: doc?.url,
      name: doc.name || "Document",
      type:
        doc.name === "CNIC"
          ? "ID Document"
          : doc.name === "Educational Document"
          ? "Certificate"
          : doc.name === "Certificates"
          ? "Achievement"
          : "Document",
      status: "Verified", // You might want to add actual status from your data
    })) || [];

  // Use the teaching slots from teacherData
  const weeklySchedule =
    teacherData?.teachingSlots?.reduce((acc, dayData) => {
      acc[dayData.day] = dayData?.slots?.map((slot) => ({
        time: `${slot.startTime} - ${slot.endTime}`,
      }));
      return acc;
    }, {}) || {};

  // Transform courses data to teaching subjects format
  const teachingSubjects =
    teacherData?.courses?.map((course) => ({
      subject: course?.courseSubjectName || "N/A",
      level: course?.courseHeaderName || "Academic",
      classes:
        course?.courseOfferingLevels?.map((level) => level?.courseLevelName) ||
        [],
    })) || [];

  const socialInputs = [
    {
      id: "youtubeUrl",
      label: "YouTube URL",
      url: teacherData?.socials?.youtubeUrl || "N/A",
      icon: FaYoutube,
      valueKey: "youtubeUrl",
    },
    {
      id: "instagramUrl",
      label: "Instagram URL",
      url: teacherData?.socials?.instagramUrl || "N/A",
      icon: FaInstagramSquare,
      valueKey: "instagramUrl",
    },
    {
      id: "twitterUrl",
      label: "Twitter URL",
      url: teacherData?.socials?.twitterUrl || "N/A",
      icon: FaTwitter,
      valueKey: "twitterUrl",
    },
    {
      id: "linkedinUrl",
      label: "LinkedIn URL",
      url: teacherData?.socials?.linkedinUrl || "N/A",
      icon: FaLinkedin,
      valueKey: "linkedinUrl",
    },
  ];

  const renderGeneralDetails = (
    <div className="w-100 text-start">
      <div className="row">
        {/* Name */}
        {/* <div className="col-12 mb-2">
          <div className="d-flex align-items-center">
            <div
              className="icon-container me-3 d-flex align-items-center justify-content-center"
              style={{ width: "24px", height: "24px", minWidth: "24px" }}
            >
              <FaUser className="text-secondary" style={{ fontSize: "14px" }} />
            </div>
            <div className="flex-grow-1">
              <small className="poppins text-muted fw-medium">
                {teacherData?.fullName || "N/A"}
              </small>
            </div>
          </div>
        </div> */}

        {/* Introduction */}
        <div className="col-12 mb-2">
          <div className="d-flex">
            {/* <div
              className="icon-container me-3 d-flex align-items-center justify-content-center"
              style={{ width: "24px", height: "24px", minWidth: "24px" }}
            >
              <PiChalkboardTeacherFill
                className="text-secondary"
                style={{ fontSize: "14px" }}
              />
            </div> */}
            <div className="flex-grow-1">
              <small className="poppins text-muted">
                {teacherData?.intro || "-"}
              </small>
            </div>
          </div>
        </div>

        {/* Email */}
        <div className="col-12 mb-2">
          <div className="d-flex align-items-center">
            <div
              className="icon-container me-3 d-flex align-items-center justify-content-center"
              style={{ width: "24px", height: "24px", minWidth: "24px" }}
            >
              <MdEmail
                className="text-secondary"
                style={{ fontSize: "14px" }}
              />
            </div>
            <div className="flex-grow-1">
              <small className="poppins text-muted text-break">
                {teacherData?.email || "-"}
              </small>
            </div>
          </div>
        </div>

        {/* Phone */}
        <div className="col-12 mb-2">
          <div className="d-flex align-items-center">
            <div
              className="icon-container me-3 d-flex align-items-center justify-content-center"
              style={{ width: "24px", height: "24px", minWidth: "24px" }}
            >
              <FaPhoneAlt
                className="text-secondary"
                style={{ fontSize: "14px" }}
              />
            </div>
            <div className="flex-grow-1">
              <small className="poppins text-muted d-flex align-items-center gap-2">
                {teacherData?.phoneNumber
                  ? (() => {
                      const result = formatInternationalPhoneNumber(
                        teacherData.phoneNumber
                      );
                      return (
                        <>
                          <img
                            src={result.flag}
                            alt={result.country}
                            style={{
                              width: 20,
                              height: 15,
                              objectFit: "cover",
                            }}
                          />
                          {/* {result.formatted.replace(`+${result.formatted.split(" ")[1]}`, "").trim()} */}
                          {result.formatted}
                        </>
                      );
                    })()
                  : "-"}
              </small>
            </div>
          </div>
        </div>

        {/* Location */}
        <div className="col-12 mb-2">
          <div className="d-flex align-items-center">
            <div
              className="icon-container me-3 d-flex align-items-center justify-content-center"
              style={{ width: "24px", height: "24px", minWidth: "24px" }}
            >
              <FaLocationDot
                className="text-secondary"
                style={{ fontSize: "14px" }}
              />
            </div>
            <div className="flex-grow-1">
              <small className="poppins text-muted">
                Lives in{" "}
                <strong>
                  {(() => {
                    const location = [
                      teacherData?.city?.name,
                      teacherData?.province?.name,
                      teacherData?.country?.name,
                    ].filter(Boolean);
                    return location.length > 0 ? location.join(", ") : "N/A";
                  })()}
                </strong>
              </small>
            </div>
          </div>
        </div>
      </div>
    </div>
  );

  const renderSocialLinks = (
    <div className="d-flex flex-column gap-2">
      {socialInputs.map((social) => {
        const IconComponent = social.icon;
        const shortURL =
          social.url?.match(/\.com\/(.*)/)?.[1]?.substring(0, 20) || "N/A";
        const isValidUrl = social.url !== "N/A";

        return (
          <div className="d-flex align-items-center" key={social.id}>
            <div
              className="icon-container me-3 d-flex align-items-center justify-content-center"
              style={{ width: "24px", height: "24px", minWidth: "24px" }}
            >
              {isValidUrl ? (
                <a
                  href={social.url}
                  target="_blank"
                  rel="noopener noreferrer"
                  style={{ color: "inherit" }}
                  className="text-decoration-none hover-blue"
                >
                  <IconComponent
                    className="text-secondary"
                    style={{ fontSize: "14px", transition: "color 0.3s" }}
                  />
                </a>
              ) : (
                <IconComponent
                  className="text-muted"
                  style={{ fontSize: "14px" }}
                />
              )}
            </div>
            <div className="flex-grow-1">
              {isValidUrl ? (
                <a
                  href={social.url}
                  target="_blank"
                  rel="noopener noreferrer"
                  className="poppins text-muted "
                  style={{ transition: "color 0.3s" }}
                  onMouseOver={(e) => (e.target.style.color = "#007bff")}
                  onMouseOut={(e) => (e.target.style.color = "")}
                >
                  <small>/{shortURL}</small>
                </a>
              ) : (
                <small className="poppins text-muted">-</small>
              )}
            </div>
          </div>
        );
      })}
    </div>
  );

  const renderTeachingModes = (
    <div className="small text-muted">
      {teacherData?.teacherAreas?.length > 0 ? (
        <p className="mb-0 mt-1">
          {teacherData?.teacherAreas?.map((area, index) => (
            <li key={index} className="d-flex align-items-center poppins">
              <GoDotFill className="me-2 text-secondary" size={14} />
              {area.area} ({area.cityName},{area.provinceName})
            </li>
          ))}
        </p>
      ) : (
        <span className="d-flex align-items-center poppins">
          <GoDotFill className="me-2 text-secondary" size={14} />
          No specific locations added
        </span>
      )}
    </div>
  );

  const renderTeachingBoards = (
    <div className="small text-muted">
      <Typography.Title level={4} style={{ margin: "0px" }}>
        Teaching Boards
      </Typography.Title>
      {teacherData?.teacherBoards?.length > 0 ? (
        <p className="mb-0 mt-1">
          {teacherData?.teacherBoards?.map((boards, index) => (
            <li
              key={index}
              className="d-flex align-items-center poppins"
              style={{ gap: "5px" }}
            >
              <GoDotFill className="text-secondary" size={14} />
              {boards?.boardName}
            </li>
          ))}
        </p>
      ) : (
        <span className="d-flex align-items-center poppins">
          <GoDotFill className="text-secondary" size={14} />
          No specific education board added
        </span>
      )}
    </div>
  );

  const renderTeacherSubjects = () => (
    <>
      <Typography.Title level={4} style={{ margin: "0px" }}>
        Teaching Subjects
      </Typography.Title>
      <div className="small">
        {teachingSubjects?.length > 0 ? (
          <div className="mb-0 mt-1 d-flex flex-column gap-2">
            {teachingSubjects.slice(0, 4).map((subject, index) => (
              <div key={index} className="d-flex flex-column gap-2 mb-2">
                <div className="d-flex align-items-center gap-2">
                  <IoBookSharp
                    className="text-secondary"
                    style={{ width: "14px", height: "14px" }}
                  />
                  <h6 className="fw-bold mb-0" style={{ color: "#586069" }}>
                    {subject.subject}
                  </h6>
                </div>
                {subject.classes.length > 0 && (
                  <div className="d-flex flex-wrap gap-1">
                    {subject.classes.map((cls, idx) => (
                      <Tag key={idx} bordered={false} color="blue">
                        {cls}
                      </Tag>
                    ))}
                  </div>
                )}
              </div>
            ))}
          </div>
        ) : (
          <div className="d-flex align-items-center">
            <IoBookSharp
              className="me-2 text-secondary"
              style={{ width: "20px", height: "20px" }}
            />
            <Tag color="blue" bordered={false}>
              No specific subjects added
            </Tag>
          </div>
        )}
      </div>
    </>
  );

  const renderExperience = () => (
    <div className="d-flex flex-column gap-2">
      <Typography.Title level={4} style={{ margin: "0px" }}>
        Experience
      </Typography.Title>
      <div>
        <h6 className="fw-bold" style={{ color: "#586069" }}>
          Academic Experience
        </h6>
        {teacherData?.teacherAcademicExperiences?.length > 0 ? (
          <p className="mb-0 mt-1">
            {teacherData.teacherAcademicExperiences.map((exp, index) => (
              <li
                key={index}
                className="d-flex align-items-center poppins"
                style={{ fontSize: "14px" }}
              >
                <div>
                  <div className="d-flex align-items-center gap-2">
                    <GoDotFill
                      className="text-secondary"
                      style={{ width: "14px", height: "14px" }}
                    />
                    {exp.position}
                  </div>
                  <div className="d-flex align-items-center ps-4">
                    <p
                      className="small text-muted mb-0 poppins"
                      style={{ fontSize: "14px" }}
                    >
                      {exp.organization}
                    </p>
                  </div>
                  <div className="d-flex align-items-center ps-4">
                    <p
                      className="small text-muted mb-0 poppins"
                      style={{ fontSize: "14px" }}
                    >
                      {exp.from} to {exp.to}
                    </p>
                  </div>
                </div>
              </li>
            ))}
          </p>
        ) : (
          <span className="d-flex align-items-center poppins">
            <GoDotFill
              className="me-2 text-secondary"
              style={{ width: "14px", height: "14px", fontSize: "14px" }}
            />
            No teaching experience added
          </span>
        )}
      </div>
      <div className="mt-2">
        <h6 className="fw-bold" style={{ color: "#586069" }}>
          Corporate Experience
        </h6>
        {teacherData?.teacherCorporateExperiences?.length > 0 ? (
          <p className="mb-0 mt-1">
            {teacherData.teacherCorporateExperiences.map((exp, index) => (
              <li
                key={index}
                className="d-flex align-items-center poppins"
                style={{ fontSize: "14px" }}
              >
                <div>
                  <div className="d-flex align-items-center gap-2">
                    <GoDotFill
                      className="text-secondary"
                      style={{ width: "14px", height: "14px" }}
                    />
                    {exp.position}
                  </div>
                  <div className="d-flex align-items-center ps-4">
                    <p
                      className="small text-muted mb-0 poppins"
                      style={{ fontSize: "14px" }}
                    >
                      {exp.organization}
                    </p>
                  </div>
                  <div className="d-flex align-items-center ps-4">
                    <p
                      className="small text-muted mb-0 poppins"
                      style={{ fontSize: "14px" }}
                    >
                      {exp.from} to {exp.to}
                    </p>
                  </div>
                </div>
              </li>
            ))}
          </p>
        ) : (
          <span className="d-flex align-items-center poppins">
            <GoDotFill
              className="me-2 text-secondary"
              style={{ width: "14px", height: "14px", fontSize: "14px" }}
            />
            No teaching experience added
          </span>
        )}
      </div>
    </div>
  );

  const renderEducation = () => (
    <div className="d-flex flex-column gap-2">
      <Typography.Title level={4} style={{ margin: "0px" }}>
        Education
      </Typography.Title>
      <div>
        {teacherData?.teacherEducations?.length > 0 ? (
          <p className="mb-0 mt-1">
            {teacherData.teacherEducations.map((edu, index) => (
              <li
                key={index}
                className="d-flex align-items-center gap-2 poppins"
              >
                <div>
                  <div className="d-flex align-items-center gap-2">
                    <GoDotFill
                      className="text-secondary"
                      style={{ width: "14px", height: "14px" }}
                    />
                    <h6 className="fw-bold mb-0" style={{ color: "#586069" }}>
                      {edu.qualification}
                    </h6>
                  </div>
                  <div className="d-flex align-items-center ps-4">
                    <p
                      className="small text-muted mb-0 poppins"
                      style={{ fontSize: "14px" }}
                    >
                      {edu.institute}
                    </p>
                  </div>
                  <div className="d-flex align-items-center ps-4">
                    <p
                      className="small text-muted mb-0 poppins"
                      style={{ fontSize: "14px" }}
                    >
                      {edu.passingYear}
                    </p>
                  </div>
                </div>
              </li>
            ))}
          </p>
        ) : (
          <span className="d-flex align-items-center poppins">
            <FaGraduationCap
              className="me-2 text-secondary"
              style={{ width: "14px", height: "14px" }}
            />
            No education added
          </span>
        )}
      </div>
    </div>
  );

  const renderWeeklyTeachingSchedule = () => (
    <>
      <div className="d-flex flex-column">
        <Typography.Title level={4} style={{ margin: "0px" }}>
          Weekly Schedule
        </Typography.Title>
      </div>
      <div>
        <p className="mb-0 mt-1">
          {Object.keys(weeklySchedule).length > 0 ? (
            <ul className="list-unstyled">
              {Object.entries(weeklySchedule).map(([day, subject], index) => (
                <div
                  key={index}
                  className="d-flex align-items-center gap-2 mb-2 poppins"
                >
                  {/*  <GoDotFill
                    className="text-secondary"
                    style={{ width: "14px", height: "14px" }}
                  /> */}
                  <div>
                    {/* <strong className="text-dark" style={{ fontSize: "14px", color:"#586069" }}>{day}</strong> */}
                    <h6 className="fw-bold mb-0" style={{ color: "#586069" }}>
                      {day}
                    </h6>
                    <div className="d-flex flex-wrap gap-2 my-2">
                      {subject?.map((slot, slotIndex) => (
                        <Tag key={slotIndex} bordered={false} color="blue">
                          <FaClock
                            className="me-1"
                            style={{ width: "12px", height: "12px" }}
                          />
                          {slot.time}
                        </Tag>
                      ))}
                    </div>
                  </div>
                </div>
              ))}
            </ul>
          ) : (
            <span className="d-flex align-items-center poppins">
              <GoDotFill
                className="me-2 text-secondary"
                style={{ width: "14px", height: "14px", fontSize: "14px" }}
              />
              No weekly teaching schedule added
            </span>
          )}
        </p>
      </div>
    </>
  );

  const renderDocuments = ({ documents = [], baseUrl = "" }) => {
    const handleOpenModal = (url) => {
      setSelectedVideoUrl(url);
      setIsModalOpen(true);
    };

    const handleCloseModal = () => {
      setIsModalOpen(false);
      setSelectedVideoUrl("");
    };

    const videoDocs = documents.filter((doc) => {
      const type = doc.type?.toLowerCase() || "";
      return type.includes("video") || /\.(mp4|webm|ogg)$/i.test(doc.url);
    });

    return (
      <div className="w-100">
        <Typography.Title level={4} style={{ margin: 0 }}>
          Videos
        </Typography.Title>

        <div className="row g-3 w-100">
          {videoDocs.length > 0 ? (
            videoDocs.map((doc, index) => {
              const fileUrl = `${baseUrl}${doc.url}`;
              const fileName = doc.name || "Untitled";

              return (
                <div className="col-12 col-md-6 col-lg-4" key={index}>
                  <div
                    className="border rounded p-3 h-100 d-flex flex-column"
                    style={{
                      boxShadow: "rgba(0, 0, 0, 0.1) 0px 4px 12px",
                    }}
                  >
                    {/* Title section */}
                    <div className="d-flex align-items-center gap-2 mb-2 w-100">
                      <IoDocuments
                        className="text-secondary"
                        style={{ width: 16, height: 16 }}
                      />
                      <h6
                        className="fw-bold mb-0 text-break w-100"
                        style={{
                          color: "#586069",
                          whiteSpace: "normal",
                          wordBreak: "break-word",
                          fontSize: "14px",
                        }}
                      >
                        {fileName === "intro Video" ? "Intro video" : fileName}
                      </h6>
                    </div>

                    {/* Video preview */}
                    <div
                      onClick={() => handleOpenModal(fileUrl)}
                      style={{ cursor: "pointer" }}
                    >
                      <video
                        className="w-100 rounded"
                        style={{
                          maxHeight: "200px",
                          objectFit: "cover",
                          pointerEvents: "none",
                        }}
                      >
                        <source src={fileUrl} />
                        Your browser does not support the video tag.
                      </video>
                    </div>
                  </div>
                </div>
              );
            })
          ) : (
            <div className="col-12">
              <span className="d-flex align-items-center poppins text-muted">
                <IoDocuments
                  className="me-2 text-secondary"
                  style={{ width: 14, height: 14 }}
                />
                No media uploaded
              </span>
            </div>
          )}
        </div>

        {/* Modal to play video */}
        <Modal
          open={isModalOpen}
          onCancel={handleCloseModal}
          footer={null}
          width={800}
          centered
          destroyOnClose
        >
          {selectedVideoUrl && (
            <video
              controls
              autoPlay
              className="w-100"
              style={{ borderRadius: "8px", maxHeight: "80vh" }}
            >
              <source src={selectedVideoUrl} />
              Your browser does not support the video tag.
            </video>
          )}
        </Modal>
      </div>
    );
  };

  // Get the cover image from teacherMedia
  const coverImage = teacherData?.teacherMedia?.find(
    (media) => media?.type === "coverImage"
  );

  const expertSubjects = teacherData.courses
    .filter((course) => course?.expert === true)
    .map((course) => course?.courseSubjectName)
    .join(", ");

  return (
    <div className="px-0">
      <div className={styles["modern-profile-header"]}>
        {/* Blue banner background */}
        <div
          className={styles["profile-banner"]}
          style={{
            backgroundImage: `linear-gradient(0deg, rgba(0, 75, 80, 0.8), rgba(0, 75, 80, 0.8)), url(${
              coverImage ? `${baseUrl}${coverImage.url}` : defaultCover
            })`,
          }}
        >
          <div className={styles["profile-info-section"]}>
            <div className={styles["profile-avatar-container"]}>
              <img
                src={
                  teacherData?.profilePic
                    ? `${baseUrl}${teacherData?.profilePic}`
                    : require("../../../assets/images/avatar.jpg")
                }
                alt="Profile"
                className={styles["profile-avatar"]}
              />
              <div
                className={`${styles["online-status-indicator"]} ${
                  online ? styles["online"] : styles["offline"]
                }`}
              ></div>
            </div>
            <div className={styles["profile-text-info"]}>
              <h1 className={styles["profile-name"]}>
                {teacherData?.fullName || "Jaydon Frankie"}
              </h1>
              <p className={styles["profile-title"]}>
                {expertSubjects
                  ? `Teaching ${expertSubjects}`
                  : "Professional Teacher"}
              </p>
            </div>
          </div>
        </div>

        {/* Main header content */}
        <div className={styles["profile-header-content"]}>
          {/* Edit button at top right */}
          <div className={styles["profile-meta-info"]}>
            <Tabs value={activeTab} onValueChange={setActiveTab}>
              <TabsList>
                {tabsData?.map((tab) => (
                  <TabsTrigger key={tab.value} value={tab.value}>
                    <tab.icon className="custom-tab-icon" />
                    <span>{tab?.label}</span>
                  </TabsTrigger>
                ))}
              </TabsList>
            </Tabs>
          </div>
        </div>
      </div>

      <div className="row">
        {screenSize === "large" || activeTab === "overview" ? (
          <div className="col-lg-4 col-md-4 col-12">
            <div
              style={cardStyles}
              className="d-flex flex-column align-items-start text-start gap-2 py-3 p-3"
            >
              <Typography.Title level={4} style={{ margin: "0px" }}>
                About Teacher
              </Typography.Title>
              {renderGeneralDetails}
            </div>
            {/* socialLinks */}
            <div
              style={cardStyles}
              className="d-flex flex-column align-items-start text-start gap-2 py-3 px-3 mt-3"
            >
              <Typography.Title level={4} style={{ margin: "0px" }}>
                Social Links
              </Typography.Title>
              {renderSocialLinks}
            </div>
            <div
              style={cardStyles}
              className="d-flex flex-column align-items-start text-start gap-2 py-3 px-3 mt-3"
            >
              <Typography.Title level={4} style={{ margin: "0px" }}>
                Teaching Modes
              </Typography.Title>
              {teacherData?.modeOfTeaching === "Both" ? (
                <div className="d-flex gap-2">
                  <Tag bordered={false} color="blue">
                    Online
                  </Tag>
                  <Tag bordered={false} color="blue">
                    Onsite
                  </Tag>
                </div>
              ) : (
                <Tag bordered={false} color="blue">
                  {teacherData?.modeOfTeaching === "Online"
                    ? "Online"
                    : "Onsite"}
                </Tag>
              )}

              {teacherData?.modeOfTeaching !== "Online"
                ? renderTeachingModes
                : null}
            </div>
            <div
              style={cardStyles}
              className="d-flex flex-column align-items-start text-start gap-2 py-3 px-3 mt-3"
            >
              {renderTeachingBoards}
            </div>
          </div>
        ) : null}

        {/* <div className="col-lg-8 col-md-8 col-12 mt-3 mt-md-0"> */}
        <div
          className={`col-lg-8 ${
            activeTab === "overview" ? "col-md-8" : "col-md-12"
          } col-12 mt-3 mt-md-0`}
        >
          <div
            className="px-0"
            style={{
              overflowX: "hidden",
              overflowY: "auto",
              height: "100%",
              marginTop: "-15px",
            }}
          >
            <Tabs value={activeTab} onValueChange={setActiveTab}>
              <TabsContent value="overview">
                <div
                  style={cardStyles}
                  className="d-flex flex-column align-items-start text-start gap-2 py-3 p-3"
                >
                  {renderTeacherSubjects()}
                </div>
                <div
                  style={cardStyles}
                  className="d-flex flex-column align-items-start text-start gap-2 py-3 p-3 mt-3"
                >
                  {renderExperience()}
                </div>
                <div
                  style={cardStyles}
                  className="d-flex flex-column align-items-start text-start gap-2 py-3 p-3 mt-3"
                >
                  {renderEducation()}
                </div>
              </TabsContent>

              <TabsContent value="subjects">
                {/* <div
                  style={cardStyles}
                  className="d-flex flex-column align-items-start text-start gap-2 py-3 p-3 mb-3"
                >
                  {renderTeachingBoards}
                </div> */}
                <div
                  style={cardStyles}
                  className="d-flex flex-column align-items-start text-start gap-2 py-3 p-3 "
                >
                  {renderTeacherSubjects()}
                </div>
              </TabsContent>

              <TabsContent value="schedule">
                <div
                  style={cardStyles}
                  className="d-flex flex-column align-items-start text-start gap-2 py-3 p-3"
                >
                  {renderWeeklyTeachingSchedule()}
                </div>
              </TabsContent>

              <TabsContent value="documents">
                <div
                  style={cardStyles}
                  className="d-flex flex-column align-items-start text-start gap-2 py-3 p-3"
                >
                  {renderDocuments({ documents, baseUrl })}
                </div>
              </TabsContent>
            </Tabs>
          </div>
        </div>
      </div>
    </div>
  );
};

export default TeacherProfilePreviewV2;

const cardStyles = {
  position: "relative",
  backgroundColor: "#ffffff",
  border: "1px solid rgba(0, 0, 0, 0.08)",
  borderRadius: "12px",
  boxShadow: "rgba(0, 0, 0, 0.1) 0px 4px 12px",
  transition: "all 0.3s cubic-bezier(0.4, 0, 0.2, 1)",
  // minWidth: "0",
  wordWrap: "break-word",
  margin: "0px",
};
